import useDependencies from './useDependencies';
import { makeStyles } from "@mui/styles";

import themeMaker, {bssMakeStyles}  from '../lib/theming';
import __t from '../lib/traduzioni';


const useBSSController = ({name, defaultValue, dependsOn, methods}) => {
    
    const classes = bssMakeStyles();    

    return {...useDependencies({name, dependsOn, methods}), methods, name, defaultValue, classes}
}

export default useBSSController;

